import Url from "./Api";
import axios from 'axios';
const authAxios = axios.create({
    baseURL: Url,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('jwtto')}`
    }
  });
  export default authAxios;